import navigationRef from '../../navigationRef';
import { Modal } from '../../ModalsManager/ModalsManager';

export const resetToRootNavigator = (onRunAfterInteractions?: () => void) => {
  Modal.close();

  navigationRef.navigate('/', { replace: true });

  onRunAfterInteractions?.();
};
